function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 15px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  font-size: 1.2em;\n  padding-bottom: 5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-style: italic;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React from "react";
import { MediumText } from "../../../../text";
import styled from "styled-components";
var FaqList = styled.div(_templateObject());
var FaqItem = styled.div(_templateObject1());
var Question = styled.p(_templateObject2());
var Answer = styled.p(_templateObject3());
var FaqsComponent = function(param) {
    var row = param.row;
    var ref;
    /*#__PURE__*/ return React.createElement(React.Fragment, null, ((ref = row.control) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ React.createElement(FaqList, null, row.control.map(function(faq, index) {
        return /*#__PURE__*/ React.createElement(FaqItem, {
            key: faq.id || index
        }, /*#__PURE__*/ React.createElement(Question, null, faq.question), /*#__PURE__*/ React.createElement(Answer, null, faq.answer));
    })) : /*#__PURE__*/ React.createElement(MediumText, null, "There are no FAQs defined at this time"));
};
export default FaqsComponent;
